import axioscommon from './axios-common';
import authHeader from './auth-header';

const defaultSettings = require('@/settings.js');
const API_URL = defaultSettings.apiUrl + '/api/customers/';

class CustomerService {
    getCustomers(inactiveToo) {
        if (inactiveToo) {
            return axioscommon.get(API_URL + 'all/', { headers: authHeader() });
        }
        return axioscommon.get(API_URL, { headers: authHeader() });
    }
    searchCustomers(query) {
        return axioscommon.get(API_URL + 'search/' + query, { headers: authHeader() });
    }
    searchByField(field, query) {
        return axioscommon.get(API_URL + 'searchby/' + field + '/' + query, { headers: authHeader() });
    }
    updateCustomer(id, data) {
        return axioscommon.put(API_URL + id, data, { headers: authHeader() });
    }
    // removeCustomer(id) {
    //     return axioscommon.delete(API_URL + id, { headers: authHeader() });
    // }
    saveCustomer(data) {
        return axioscommon.post(API_URL, data, { headers: authHeader() });
    }
    createUser(data) {
        return axioscommon.post(API_URL + 'signCustomer', data, { headers: authHeader() });
    }
}

export default new CustomerService();
